import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import AdvShipIndexActions, { AdvShipIndexTypes } from '../Stores/AdvShipIndex/Actions';

const getAppStore = state => state.app;

export function* advShipIndexFetchAdvShipIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(AdvShipIndexActions.advShipIndexFetchAdvShipIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `advShip/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        AdvShipIndexActions.advShipIndexFetchAdvShipIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(AdvShipIndexActions.advShipIndexFetchAdvShipIndexLoading(false));
  }
}

export function* advShipIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/advShipDetail/update/${hdrId}`));
}

export function* advShipIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/ADV_SHIP/${hdrId}/AdvShipHdr`));
}

export function* advShipIndexResetAdvShipFServ02({ hdrIds }) {
  try {
    yield put(AdvShipIndexActions.advShipIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `advShip/fServProcess/RESET_ADV_SHIP_F_SERV_02/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(AdvShipIndexActions.advShipIndexResetAdvShipFServ02Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(AdvShipIndexActions.advShipIndexWorkspaceLoading(false));
  }
}

export function* advShipIndexOpenDocument({ hdrId }) {
  try {
    yield put(AdvShipIndexActions.advShipIndexFetchAdvShipIndexLoading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrId,
      docStatus: 'OPEN_PARTIAL_QTY'
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      'advShip/transitionToStatus',
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(AdvShipIndexActions.advShipIndexFetchAdvShipIndexLoading(false));
  }
}

export function* advShipIndexTransitionToVoid({ hdrIds }) {
  try {
    yield put(AdvShipIndexActions.advShipIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      'advShip/transitionAllToVoid',
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(AdvShipIndexActions.advShipIndexResetAdvShipFServ02Success([]));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(AdvShipIndexActions.advShipIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(AdvShipIndexTypes.ADV_SHIP_INDEX_GO_TO_DOCUMENT, advShipIndexGoToDocument),
  takeLatest(AdvShipIndexTypes.ADV_SHIP_INDEX_GO_TO_AUDIT, advShipIndexGoToAudit),
  takeLatest(AdvShipIndexTypes.ADV_SHIP_INDEX_FETCH_ADV_SHIP_INDEX, advShipIndexFetchAdvShipIndex),
  takeLatest(
    AdvShipIndexTypes.ADV_SHIP_INDEX_RESET_ADV_SHIP_F_SERV02,
    advShipIndexResetAdvShipFServ02
  ),
  takeLatest(AdvShipIndexTypes.ADV_SHIP_INDEX_OPEN_DOCUMENT, advShipIndexOpenDocument),
  takeLatest(AdvShipIndexTypes.ADV_SHIP_INDEX_TRANSITION_TO_VOID, advShipIndexTransitionToVoid)
];
